<script lang="ts">import { ref_get_return_function, ref_swap_function, } from "../../ts/ref/ref_functions";
import { ArrowDownUp } from "@lucide/svelte";
import { DEFAULT_REFERRAL_ID } from "../../ts/app_consts";
// ===========================================
let { pool_id, token_account_ids } = $props();
let token_in = $derived(token_account_ids?.[1]);
let amount_in = $state("0");
let token_out = $derived(token_account_ids?.[0]);
let min_amount_out = $state("0");
let referral_id = DEFAULT_REFERRAL_ID();
// ===========================================
// ===========================================
// Rotates token_in and token_out by swapping their values
function rotateTokens(currentTokenIn, currentTokenOut) {
    // Return a new object with values swapped
    return {
        token_in: currentTokenOut,
        token_out: currentTokenIn,
    };
}
// Click handler: swap the current values and reassign
function onRotateClick() {
    const rotated = rotateTokens(token_in, token_out);
    token_in = rotated.token_in;
    token_out = rotated.token_out;
}
// Function to handle amount input changes
function handleAmountInChange(event) {
    const target = event.target;
    amount_in = target.value;
    min_amount_out = "0"; // Reset min_amount_out when amount_in changes
}
// ===========================================
// ===========================================
async function get_return() {
    console.log("=========== get_return details =========");
    console.log("pool_id", pool_id);
    console.log("token_in", token_in);
    console.log("amount_in", amount_in);
    console.log("token_out", token_out);
    console.log("================================");
    const return_results = await ref_get_return_function(pool_id, token_in, amount_in, token_out);
    console.log("================================");
    console.log("swap component get return results", return_results);
    min_amount_out = return_results;
    console.log("================================");
    return return_results;
}
// get_return();
// setInterval(get_return, 10_000);
// ===========================================
// ===========================================
async function swap_tx() {
    console.log("=========== swap details =========");
    console.log("pool_id", pool_id);
    console.log("token_in", token_in);
    console.log("amount_in", amount_in);
    console.log("token_out", token_out);
    console.log("================================");
    const swap_results = await ref_swap_function(pool_id, token_in, amount_in, token_out, min_amount_out, referral_id);
    console.log("================================");
    console.log("swap component swap results", swap_results);
    console.log("================================");
}
</script>

<!--  -->
<!--  -->

<!-- COMPONENT_SWAP_SWAP -->
<div>
  <p>TOKEN IN<br />{token_in}</p>
  <input
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    oninput={handleAmountInChange}
    value={amount_in}
  />
  <button onclick={onRotateClick}><ArrowDownUp /></button>
  <p>TOKEN OUT<br />{token_out}</p>
  <input type="number" bind:value={min_amount_out} disabled />
  <button onclick={get_return}>GET SWAP QUOTE</button>
  <button onclick={swap_tx}>EXECUTE SWAP</button>
  <p style="text-align: center; font-size: 10px;">
    RHEA INNER BALANCE SWAPPING
  </p>
</div>

<!--  -->
<!--  -->

<style>
  div {
    background-color: white;
    color: #474747;
    margin: 10px;
    width: 500px;
    max-width: 90vw;
    text-align: left;
    padding: 3px;
    box-sizing: border-box;
  }
  input {
    font-size: 20px;
    font-family: Arial, Helvetica, sans-serif;
    box-sizing: border-box;
  }
  button,
  input {
    box-sizing: border-box;
    width: 100%;
    padding: 2px;
    margin: 2px;
  }
</style>
